import React from "react";
import { ContainerSection } from "../../../components/ContainerSecions";
import { FormProvider, useForm } from "react-hook-form";
import { Box } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import dayjs from "dayjs";
import {
  useCalibrationUncertainty,
  useTypesUncertainty,
} from "@services/servicesGenericsTables";
import { IFormFilterUncertaintyInputs } from "@app/types/uncertainty.types";
import {
  MAutocomplete,
  MButton,
  MDatePicker,
  ResponsiveFormContainer,
} from "@app/components";

const FilterUncertainty = () => {
  const { setQuery } = useCalibrationUncertainty();
  const form = useForm<IFormFilterUncertaintyInputs>({ mode: "all" });
  const { typesUncertaintyList } = useTypesUncertainty();

  const submit = (data: IFormFilterUncertaintyInputs) => {
    setQuery(data);
  };

  const clearFilters = () => {
    form.reset();
    setQuery({});
  };

  return (
    <ContainerSection label="Filtros">
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(submit)}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <ResponsiveFormContainer columns={4}>
              <MAutocomplete
                key={JSON.stringify(form.getValues("type_uncertainty"))}
                name="type_uncertainty"
                options={typesUncertaintyList}
                label="Tipo incertidumbre"
                getOptionLabel={(option) => option.nombre}
                multiple={true}
              />
              <MDatePicker
                name="date_from"
                pickerType="date"
                label="Fecha emisión desde"
                maxDate={dayjs(form.watch("date_to"))}
              />
              <MDatePicker
                name="date_to"
                pickerType="date"
                label="Fecha emisión hasta"
                minDate={dayjs(form.watch("date_from"))}
              />
            </ResponsiveFormContainer>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <MButton
                variant="outlined"
                color="primary"
                sx={{ textTransform: "uppercase" }}
                text="Filtrar"
                type="submit"
                startIcon={<FilterAltIcon />}
              />
              <MButton
                variant="outlined"
                color="secondary"
                sx={{ textTransform: "uppercase", ml: 2 }}
                text="Limpiar"
                onClick={clearFilters}
              />
            </Box>
          </Box>
        </form>
      </FormProvider>
    </ContainerSection>
  );
};

export default FilterUncertainty;
